import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<span class=\"loading-spinner\">\n  <FaIcon @icon=\"spinner\" @spin={{true}} />\n</span>\n", {
  moduleName: "ilios-common/components/loading-spinner.hbs"
});